export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/storyboards.45af1c7.svg";